import React from 'react';
import { connect } from 'react-redux';
import Text from './Text';
import FilterOpenedAt from '../components/FilterOpenedAt';
import { applyFilter, hideSearchDetails, fetchShops } from '../actions';
import config from '../config/';

const SearchDetails = ({onApply, onCloseClick, search, country}) => {
  const {filter} = search;
  let timeFilter
  let luggageFilter;
  let boxesFilter;

  const disableLuggage = config.countryOptions[country].disableLuggage;
  const disableBoxes = config.countryOptions[country].disableBoxes;
  const disableTime = config.countryOptions[country].disableTime;

  return (
    <div className="search-details mt-1">
    <div className="row">
        <div className="col-12">

            {disableTime ? null : (
            <div className="form-check">
                <FilterOpenedAt
                    ref={n => timeFilter = n}
                    onChange={() => {
                        setTimeout(() => {
                            onCheckboxChange(luggageFilter, boxesFilter, timeFilter, onApply);
                        }, 100);
                    }}
                />
            </div>
            )}

          {disableLuggage ? null : (
            <div className="form-check">
              <label className="form-check-label">
                <input
                    className="form-check-input"
                    type="checkbox"
                    ref={n => luggageFilter = n}
                    defaultChecked={filter.luggage}
                    onChange={() => {
                        onCheckboxChange(luggageFilter, boxesFilter, timeFilter, onApply);
                    }}
                    />
                <Text id="search-detail.luggage.label"/>
              </label>
            </div>
          )}

          {disableBoxes ? null : (
            <div className="form-check">
              <label className="form-check-label">
                <input
                    className="form-check-input"
                  type="checkbox"
                    ref={n => boxesFilter = n}
                    defaultChecked={filter.boxes}
                    onChange={() => {
                        onCheckboxChange(luggageFilter, boxesFilter, timeFilter, onApply);
                    }}
                />
                <Text id="search-detail.boxes.label"/>
              </label>
            </div>
          )}

        </div>
    </div>
    </div>
  );
};

const onCheckboxChange = (luggageFilter, boxesFilter, timeFilter, onApply) => {

    const filter = {
        luggage: luggageFilter && luggageFilter.checked,
        boxes: boxesFilter && boxesFilter.checked,
        time: timeFilter && timeFilter.state
    };
      onApply(filter);
};

const mapStateToProps = ({search, config}/*, ownprops */) => ({
  search,
  country: config.country
});

const mapDispatchToProps = dispatch => ({
  onApply: (filter) => {
    dispatch(applyFilter(filter));
    dispatch(fetchShops());
  },

  onCloseClick: () => {
    dispatch(hideSearchDetails());
  }
});

const SearchDetailsContainer = connect(mapStateToProps, mapDispatchToProps)(SearchDetails);
export default SearchDetailsContainer;
